import React, { FC, ComponentType, useMemo } from 'react';
import {
  Route as ReactDOMRoute,
  RouteProps as ReactDOMRouterProps,
  Redirect,
} from 'react-router-dom';

import { useAuth } from '../hooks/Auth';
import AuthLayout from '~/pages/_Layouts/Auth';
import DefaultLayout from '~/pages/_Layouts/Default';

interface RouteProps extends ReactDOMRouterProps {
  isPrivate?: boolean;
  component: ComponentType;
}

const Route: FC<RouteProps> = ({
  isPrivate = false,
  component: Component,
  ...rest
}) => {
  const { user } = useAuth();

  const Layout = useMemo(
    () => (isPrivate ? DefaultLayout : AuthLayout),
    [isPrivate]
  );

  return (
    <ReactDOMRoute
      {...rest}
      render={({ location }) => {
        // Se a rota é privada e o usuário não está logado, redireciona para o login.
        if (isPrivate && !user) {
          return (
            <Redirect
              to={{ pathname: '/dentistabarueri', state: { from: location } }}
            />
          );
        }

        if (location.pathname === '/') {
          return (
            <Redirect
              to={{ pathname: '/dentistabarueri', state: { from: location } }}
            />
          );
        }

        // Se a rota NÃO é privada e o usuário ESTÁ logado, redireciona para o dashboard.
        if (!isPrivate && user) {
          return (
            <Redirect
              to={{ pathname: '/dashboard', state: { from: location } }}
            />
          );
        }

        // Se nenhuma das condições de redirect for atendida, renderiza o componente.
        return (
          <Layout>
            <Component />
          </Layout>
        );
      }}
    />
  );
};

export default Route;
